import AuthKeysCreate from './AuthKeysCreate';

export default AuthKeysCreate;
